import { Line } from '@models/line.model';
import { PartNumber } from '@models/partNumber.model';
import {User} from "@models/user.model";

export class ToolRequestHistory {
    public id: number;
    public name: string;
    public partNumber: PartNumber;
    public line: Line;
    public status: string;
    public closeReason: string;
    public createdBy: User;
    public createdDate: string;
    public modifiedBy: User;
    public modifiedDate: string;
    public type: string;
    public toolRequestId: number;

    constructor(toolRequestHistory: any = {}) {
        this.id = toolRequestHistory.id || 0;
        this.name = toolRequestHistory.name || '';

        if (toolRequestHistory.partNumber) {
            this.partNumber = this.mapPartNumber(toolRequestHistory.partNumber);
        }
        this.line = this.mapLine(toolRequestHistory.line);
        if (toolRequestHistory.createdBy) {
            this.createdBy = new User(toolRequestHistory.createdBy);
        }
        this.createdDate = toolRequestHistory.createdDate || '';
        if (toolRequestHistory.modifiedBy) {
            this.modifiedBy = new User(toolRequestHistory.modifiedBy);
        }
        this.modifiedDate = toolRequestHistory.modifiedDate || '';
        this.status = toolRequestHistory.status || '';
        this.type = toolRequestHistory.type  || '';
        this.closeReason = toolRequestHistory.closeReason;
        this.toolRequestId = toolRequestHistory.toolRequestId;
    }
    mapPartNumber(partNumber) {
        return new PartNumber(partNumber);
    }
    mapLine(line) {
        return new Line(line);
    }
}
